import * as types from './types';

export const updateNetWorkOffLine = () => ({
  type: types.UPDATE_OFFLINE,
});
export const updateNetWorkOnLine = () => ({
  type: types.UPDATE_ONLINE,
});
export const updateNetWorkStatus = () => ({
  type: types.UPDATE_WEAK,
});
export const resetNetWork = () => ({
  type: types.RESET_NETWORK,
});
export const resetAllNetWork = () => ({
  type: types.RESET_ALL_NETWORK,
});

export const resetFollow = () => ({
  type: types.RESET_FOLLOWING,
});
export const saveUserDetailsInfo = (info) => ({
  type: types.SAVE_USER_INFO,
  payload: info,
});
